export default __webpack_public_path__ + "static/media/OnLogic.3ae12243.png";